class statisticsModalCtrl {
    constructor($scope, $uibModalInstance, httpRequest, $filter) {
        $scope.turnoutPeriod = $filter('date')(new Date(), 'yyyyMM')
        $scope.dateConfig = {
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
            endDate: new Date()
        }

        $scope.init = function () {
            httpRequest.get_turnoutAccountStatistics($scope.turnoutPeriod).then(res => {
                $scope.modalDetailsList = res.data.value
            })
        }
        $scope.$watch('turnoutPeriod', () => {
            $scope.init()
        })
        $scope.cancel = () => {
            // $uibModalInstance.dismiss();
            $uibModalInstance.close()
        }

    }
}

statisticsModalCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', '$filter']
export default statisticsModalCtrl


// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/rollout/statisticsModalCtrl.js